import { useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

export const useSearchParams = () => {
  const history = useHistory()
  const { search } = useLocation()

  const searchParams = useMemo(() => new URLSearchParams(search), [search])

  const setSearchParams = (params) => {
    Object.keys(params).forEach((key) => searchParams.set(key, params[key]))
    history.push({ search: searchParams.toString() })
  }

  return [searchParams, setSearchParams]
}
